import { createSlice, PayloadAction } from "@reduxjs/toolkit";
import { CommonEnums } from "../../enums/common.enums";

const initialState = {
  subscriptionListReset: false,
  subscriptionsTab: CommonEnums.subscriptionType.property_marketing.key,
  listingTab: CommonEnums.listingType?.for_rent?.key,
};

export const subscriptionSlice = createSlice({
  name: "subscription",
  initialState,
  reducers: {
    setSubscriptionListReset: (state) => {
      state.subscriptionListReset = !state.subscriptionListReset;
    },

    setSubscriptionsTab: (state, action) => {
      state.subscriptionsTab = action?.payload;
    },

    setListingTab: (state, action) => {
      state.listingTab = action?.payload;
    },
  },
});

export const subscriptionAction = subscriptionSlice.actions;
export const subscriptionReducer = subscriptionSlice.reducer;
